import React, { Suspense, lazy } from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";

import Spinner from "./components/Spinner/Spinner.jsx";

import store from "./store/store.js";

// Lazy loading components
const Dashboard = lazy(() => import("./layouts/Dashboard/Dashboard.jsx"));
const Login = lazy(() => import("./layouts/Login/Login.jsx"));
const Logout = lazy(() => import("./layouts/Logout/Logout.jsx"));
const NotFound = lazy(() => import("./components/NotFound/NotFound.jsx"));

const hist = createBrowserHistory();

function App() {
  return (
    <Provider store={store}>
      <Router history={hist}>
        <Suspense
          fallback={
            <div className="vh-100 d-flex justify-content-center align-items-center">
              <div className="text-center">
                <Spinner />
              </div>
            </div>
          }
        >
          <Switch>
            <Route path="/" exact component={Login}></Route>
            <Route path="/dashboard" component={Dashboard}></Route>
            <Route path="/logout" component={Logout} />
            <Route component={NotFound} />
          </Switch>
        </Suspense>
      </Router>
    </Provider>
  );
}

export default App;
